import {IProgramClassDetailsState} from './IProgramClassDetailsState';
import {programClassDetailsInitialState} from './programClassDetails.initialState';

export const programClassDetailsReducer = {
  resetActiveEntry: (state: IProgramClassDetailsState) => {
    state.activeEntity = programClassDetailsInitialState.activeEntity;
  },
};
